module.exports = __webpack_public_path__ + "static/media/4.d6e6ccf2.png";